module.exports = __webpack_public_path__ + "static/Notion-b9fcaf8d4e57739e054399b49fbdd6e8.jpg";